exports.install = function (Vue, options) {
	//获取管理员列表
	Vue.prototype.getuserT = function(value={})
	{
		value.limitPage=this.$store.state.production.page;
		value.limitCount=this.$store.state.production.pagesize;
		return this.axiosget("/api/pt/user/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('userT',response.data.data);
			}
		})
	};
	//获取所有管理员列表
	Vue.prototype.getuserTall = function(value={})
	{
		return this.axiosget("/api/pt/user/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('userT',response.data.data);
			}
		})
	};
	//添加管理员
	Vue.prototype.adduserT = function(value)
	{
		return this.axiospost("/api/pt/user/add",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getuserT();
			}
			return response;
		});
	};
	//修改管理员
	Vue.prototype.edituserT = function(value)
	{
		return this.axiospost("/api/pt/user/update",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getuserT();
			}
			return response;
		});
	};
	//删除管理员
	Vue.prototype.deluserT = function(value)
	{
		this.axiospost("/api/pt/user/delete",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getuserT();
			}
		});
	};
}